import { Routes } from "akademika/akamont/constants/Routes";
import { PriceListFilters } from "akademika/akamont/models/PriceListFilters";
import { FilterController } from "../sharedControllers/FilterController";
import { GetDateOnlyString } from "akademika/akamont/utils/FormatUtil";

/**
 * @namespace akademika.akamont.pages.servicePriceList
 */
export default class ServicePriceList extends FilterController {
  route = Routes.SERVICE_PRICE_LIST;
  parentRoute = Routes.DASHBOARD;

  public override onInit() {
    super.onInit();

    const filterData: PriceListFilters = {
      date: GetDateOnlyString(new Date()),
      serviceIds: undefined,
      partnerId: undefined,
      businessUnitIds: undefined,
    };
    this.initFilters(filterData, "api/ServicePrice/GetServicePriceList", true);
  }

  public async onRouteMatched() {
    this.fetchModel(
      "api/ServicePrice/GetSerivcePriceFilterOptions",
      "filterOptions"
    );
  }

  protected override resetFiltersModel() {
    const todayStr = GetDateOnlyString(new Date());
    (this._defaultFilters as PriceListFilters).date = todayStr;
    super.resetFiltersModel();
  }

  public addNewServicePrice() {
    this.navTo(Routes.SERVICE_PRICE_ADD);
  }

  public goToServicePriceDetails(servicePriceId: number) {
    this.navTo(Routes.SERVICE_PRICE_DETAILS, {
      servicePriceId: servicePriceId,
    });
  }
}
